<template>
  <footer class="bg-gray-100 text-gray-600 py-6 mt-12 border-t">
    <div class="max-w-5xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center text-sm">
      <p>© {{ currentYear }} Melissa McCallum. All rights reserved.</p>

      <nav class="flex gap-4 mt-4 sm:mt-0">
        <RouterLink to="/privacy" class="hover:underline">Privacy Policy</RouterLink>
        <RouterLink to="/contact" class="hover:underline">Contact</RouterLink>
        <a href="mailto:info@example.com" class="hover:underline">Email</a>
      </nav>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear()
</script>
